import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import {useTranslation} from "react-i18next";
import {DateObservable} from "../../../stores/observables/dateObservable";
import {DayObservableList} from "../../../stores/observables/dayObservableList";
import "./eventDayEdit.sass";
import classNames from "classnames";
import {DayWeekState} from "../../../shared/enums/eventDayWeekState";
import parse from "html-react-parser";
import {utcToZonedTime} from "date-fns-tz";
import {Col, Row} from "reactstrap";
import {runInAction} from "mobx";

export interface IDayWeekEditProps {
  eventStartDate: DateObservable;
  weekdays: DayObservableList;
  timezone: string;
  isEditing: boolean;
}

const EventDayEdit: React.FC<IDayWeekEditProps> = ({
  eventStartDate,
  weekdays,
  timezone,
  isEditing
}) => {
  const {t} = useTranslation(["event"]);

  useEffect(() => {
    if (eventStartDate.date && !isEditing) {
      weekdays.resetSelections();
      let occurrence = utcToZonedTime(eventStartDate.date, timezone).getDay();

      const weekDay = weekdays.weekdayList.find(
        (value) => value.index === occurrence
      );

      runInAction(() => {
        weekDay && (weekDay.state = DayWeekState.autoSelected);
      });
    }
  }, [eventStartDate.date]);

  function onDaySelection(day: number) {
    const selectedWeekday = weekdays.weekdayList.find(
      (value) => value.index === day
    );

    // Cannot un-check auto selected and disabled week number
    if (
      selectedWeekday?.state === DayWeekState.autoSelected ||
      selectedWeekday?.state === DayWeekState.disabled ||
      !selectedWeekday
    ) {
      return;
    }

    runInAction(() => {
      // Toggle weekday to selected and default state.
      selectedWeekday.state =
        selectedWeekday.state === DayWeekState.selected
          ? DayWeekState.default
          : DayWeekState.selected;

      // force-select remaining day if only two are still selected
      weekdays.enforceMinimumSelectedDays();
    });
  }

  return (
    <div className="event-day-edit" data-testid="event-day-edit">
      <Row xs={2}>
        <Col xs={12} className={"message-label"}>
          {eventStartDate.date &&
            parse(t("event:messages.weekdaysSelectorSummary"))}
        </Col>
        <Col xl={12} className={"day-container day-button-container"}>
          {weekdays.weekdayList.map((value) => {
            let testId = `day_${value.index}`;
            return (
              <button
                data-testid={testId}
                key={value.index}
                onClick={(event) => onDaySelection(value.index)}
                className={classNames("day-button", value.state)}
              >
                {t(value.label)}
              </button>
            );
          })}
        </Col>
      </Row>
    </div>
  );
};
export default observer(EventDayEdit);
